class routing {
	gonavigateTo(rotuer) {
		
				try {
				uni.navigateTo({
					url: rotuer
				})
				} catch (e) {
					console.log(rotuer,e)
				}
		
	}
	msg(msg){
		uni.showToast({
			title: msg,
			icon: 'none'
		})
	}
	setCache(name, data) {
		try {
			uni.setStorageSync(name, data);
		} catch (e) {
			//console.log(e)
		}
	}
	title_name(name){
		uni.setNavigationBarTitle({
		    title: name
		});
	}
	
	goswitchTab(rotuer) {
		try {
		   uni.switchTab({
		   
		   	url: rotuer,
		   
		   	success: (res) => {
		   
		   		let page = getCurrentPages().pop(); //跳转页面成功之后
		   
		   		if (!page) return;
		   
		   	}
		   
		   });
		} catch (e) {
			console.log(rotuer,e)
		}
	
	}
	gobank(){
		try {
	        uni.navigateBack({
				delta:1,//返回层数，2则上上页
			})
		} catch (e) {
			console.log(rotuer,e)
		}			
	}

	open(url,typetext) {
		try {
		   plus.runtime.openURL(url, function(res) {
		       console.log(res,"跳转失败"); 
			   if(res){
				   console.log('执行复制')
				  uni.setClipboardData({
				  	data: url,
				  	success: function () {
				  			uni.showToast({
				  				title: '复制成功,请到'+typetext+'打开',
				  				icon: 'none'
				  			})
				  		}
				  }); 
			   }
			
		   });  
		} catch (e) {
            console.log('执行复制')
			uni.setClipboardData({
				data: url,
				success: function () {
						uni.showToast({
							title: '复制成功,请到'+typetext+'打开',
							icon: 'none'
						})
					}
			});
			console.log('执行成功')
		}
    }
}
let routingFunc = new routing();
export default routingFunc;
